<template>
	<div>
		<div class="md-layout" v-if="providerList.length > 0">
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="overflow-x: scroll;margin-bottom: 15px">
				<div class="slot-container">
					<div class="slot-provider" :class="{'slot-provider-active': provider == ''}" @click="getSlot('')">ទាំងអស់</div>
					<div v-for="pd in providerList" class="slot-provider" :class="{'slot-provider-active': provider == pd.id}" @click="getSlot(pd.id)">{{pd.name}}</div>
				</div>
			</div>
		</div>
		<loading v-if="!loaded"/>
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-xsmall-size-60 md-small-size-70 md-medium-size-70 md-size-80" style="margin-bottom: 18px">
				<div class="form__tabs__wrap">
					<form>
						<div class="form__grp">
							<!-- <label for="referral">{{$store.state.lang.text.referral_info[$store.state.lang.language]}}</label> -->
							<input id="referral" type="text" v-model="search.text" :placeholder="$store.state.lang.text.search[$store.state.lang.language]">
						</div>
					</form>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-40 md-small-size-30 md-medium-size-30 md-size-20" style="margin-bottom: 18px">
				<div class="tooltip">
					<button style="
						background-color: #135F87;
						border: 0px;
						border-radius: 10px;
						padding: 12px 18px;
						cursor: pointer;
						width: 100%;
						color: #FFF;
						font-family: 'Poppins', 'Koh Santepheap', sans-serif;
					" @click="getGame()">{{$store.state.lang.text.search[$store.state.lang.language]}}</button>
					</div>
			</div>

			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="text-align: center" v-if="loaded && gameList.length == 0">មិនមាន</div>
			<div class="md-layout-item md-xsmall-size-33 md-small-size-33 md-medium-size-25 md-size-20 margin-bottom-15" v-for="game in gameList">
				<div class="game-list" @click="openGame(game.hash)">
					<!-- <div style="width: 36px; height: 36px; position: absolute; background-color: white;border-bottom-right-radius: 20px;">
						<img src="@/assets/img/providers/kagaming.png" alt="">
					</div> -->
					<img class="game-list-image" :src="config.getGameImageUrl(game.hash)">
					<span>{{game.name}}</span>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="text-align: center" v-if="loaded && loadMore">
				<div class="create__btn"><a class="cmn--btn" @click="getGame(true)" style="cursor: pointer;"><span>បង្ហាញបន្ថែម</span></a></div>
			</div>
		</div>
	</div>

</template>

<script>

	import { Datetime } from 'vue-datetime';

	export default {
		components: {

		},
		mounted() {
			window.scrollTo(0,0);
		},
		created() {
			this.getGame();
			this.getProvider();
		},
		methods: {
			getProvider() {
				this.$http.get(this.config.api + "/public/game/slot_provider_list").then(res => {
						if (res.body.status == 'success') {
							// window.open(res.body.data.url, "_blank");
							this.providerList = res.body.data;
							// this.$store.state.authentication.url = res.body.data.url;
						}
					})
			},
			getSlot(provider) {
				this.provider = provider;
				this.getGame();
			},
			getGame(more = false) {
				this.loadMore = false;
				this.loaded = false;
				this.$http.post(this.config.api + "/public/game/search", {
					text: this.search.text,
					provider: this.provider,
					game_type: 1,
					offset: more ? this.gameList.length : 0
				}).then(res => {
					if (res.body.status == 'success') {
						this.loaded = true;
						if (res.body.data.length == 50) this.loadMore = true;
						else this.loadMore = false;
						this.gameList = more ? this.gameList.concat(res.body.data) : res.body.data;
					}
				})
			},
			openGame(hash) {
				// this.$router.push("/play/" + hash);
				if(this.$store.state.authentication.loggedIn) {
					this.$store.state.authentication.loading = true;
					this.$http.get(this.config.api + "/user/authed/game/open/" + hash).then(res => {
						this.$store.state.authentication.loading = false;
						if (res.body.status == 'success') {
							// window.open(res.body.data.url, "_blank");
							let url = res.body.data.url;

							if(url.includes("joker123.cam99gaming")) {
								// window.open(url, "_blank");
								var newWindow = window.open(url);
								newWindow.opener = null;
							} else {
								this.$store.state.authentication.url = res.body.data.url;
							}
						}
					})
				} else {
					this.$router.push("/login");
				}
			}
		},
		computed: {
		},
		data() {
			return {
				loaded: false,
				loadMore: false,
				provider: "",
				search: {
					text: ""
				},
				gameList: [],
				providerList: []
			}
		}
	}
</script>

<style>
	.slot-container {
		display: flex;
		flex-direction: row;
		margin-bottom: 15px;
	}
	.slot-provider-active {
		background-color: #135F87;
	}
	.slot-provider {
		cursor: pointer;
		white-space: nowrap;
		margin-right: 8px;
		border: 1px solid #135F87;
		border-radius:15px;
		text-align: center;
		justify-content: center;
		align-items: center;
		padding: 8px 12px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Bet/Slot.vue